import { Field } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';

export const ButtonField: Field = (props) => {
  const {
    idSchema,
    onChange,
    schema: { title, description },
    disabled,
  } = props;

  return (
    <div className="form-group">
      <div className={'wrapper'}>
        <button
          id={idSchema.$id}
          type="submit"
          className="btn btn-primary"
          onClick={() => {
            onChange(true);
          }}
          disabled={disabled}
        >
          {title}
        </button>
      </div>
      <small className="text-muted form-text">
        <MarkdownContent>{description as string}</MarkdownContent>
      </small>
    </div>
  );
};
